module.exports = __webpack_public_path__ + "img/sysyw.90679627.png";